import { makeApiUrl, makeAxiosHttpClient } from "../http";

import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { LoadAccountByToken } from "../../../data/usecases/load-account-by-token";

export const makeLoadAccountByToken = (): LoadAccountByToken =>
  new LoadAccountByToken(
    makeApiUrl("/login"),
    makeAuthorizeHttpClientDecorator()
  );
